// extracted by mini-css-extract-plugin
export default {"productCarousel":"Q1-z"};